import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DropzoneComponent } from './dropzone.component';
import { DragDropDirective } from './dragdrop.directive';

@NgModule({
  declarations: [DropzoneComponent, DragDropDirective],
  imports: [CommonModule],
  exports: [DropzoneComponent, DragDropDirective]
})
export class DropzoneModule {}
